export default __webpack_public_path__ + "img/eqZYHiMd.95c25ab6.svg";